"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initChat = exports.WebChat = exports.WebChatView = void 0;
var utils_1 = require("./utils");
var chat_lcw_1 = require("./chat-lcw");
var file_saver_1 = require("file-saver");
var WebChatView;
(function (WebChatView) {
    WebChatView[WebChatView["PrivacyPolicy"] = 0] = "PrivacyPolicy";
    WebChatView[WebChatView["About"] = 1] = "About";
    WebChatView[WebChatView["Chat"] = 2] = "Chat";
})(WebChatView = exports.WebChatView || (exports.WebChatView = {}));
var WebChat = /** @class */ (function () {
    function WebChat(template, styleOptions, adaptiveCardHostConfig) {
        var _a, _b, _c;
        this.transcript = [];
        this.newMessagesCounter = 0;
        this.isPrivacyPolicyAccepted = false;
        this.template = template;
        this.styleOptions = styleOptions;
        this.adaptiveCardHostConfig = adaptiveCardHostConfig;
        this.botId = template.dataset.botId;
        this.botOptions = {
            id: this.botId,
            title: (_a = template.dataset.botTitle) !== null && _a !== void 0 ? _a : null,
            hidePrivacyPolicy: typeof template.dataset.botHidePrivacyPolicy !== 'undefined',
            hideMessageField: typeof template.dataset.botHideMessageField !== 'undefined',
            showUploadButton: typeof template.dataset.botShowUploadButton !== 'undefined',
            initialMessage: (_b = template.dataset.botInitialMessage) !== null && _b !== void 0 ? _b : null,
            version: (_c = template.dataset.botVersion) !== null && _c !== void 0 ? _c : WebChat.botVersionDefault,
        };
        this.initDom();
        this.initListeners();
        if (this.botOptions.hidePrivacyPolicy) {
            this.setView(WebChatView.Chat);
            this.acceptPrivacyPolicyLoadAndConnect();
        }
    }
    WebChat.prototype.initDom = function () {
        var _a;
        var element = this.template.content.cloneNode(true);
        var button = document.querySelector(WebChat.selector.chatToggler);
        (_a = button === null || button === void 0 ? void 0 : button.parentNode.insertBefore(element, button === null || button === void 0 ? void 0 : button.nextSibling)) !== null && _a !== void 0 ? _a : document.body.appendChild(element);
        this.element = document.querySelector(WebChat.selector.chatFrame);
        this.openChatFrame();
        if (!this.isPrivacyPolicyAccepted)
            this.setView(WebChatView.PrivacyPolicy);
        if (this.element.querySelector(WebChat.selector.chatSendBox)) {
            this.sendBox = this.element.querySelector(WebChat.selector.chatSendBox);
            this.sendBox.minLength = 1;
            this.sendBox.maxLength = WebChat.sendBoxMaximumLength;
            this.sendBox.insertAdjacentHTML('afterend', "<span class=\"chat-wc-send-box-counter\"><span class=\"js-chat-wc-send-box-counter\">0</span>/".concat(WebChat.sendBoxMaximumLength, "</span>"));
            this.sendBoxCounter = this.element.querySelector(WebChat.selector.chatSendBoxCounter);
        }
        this.resizeCorner = document.createElement('div');
        this.resizeCorner.classList.add(WebChat.cssClass.chatResizeCorner);
        this.element.appendChild(this.resizeCorner);
    };
    WebChat.prototype.initListeners = function () {
        var _this = this;
        this.element.addEventListener('click', function () {
            if (_this.element.querySelector(WebChat.selector.chatMenu).classList.contains(WebChat.cssClass.chatMenuOpen))
                _this.hideMenu();
        });
        this.element.addEventListener('focusout', function (e) {
            var activeElement = e.relatedTarget;
            if (!activeElement)
                return;
            if (!_this.element.contains(activeElement)) {
                _this.hideMenu();
                _this.closeChatFrame();
                return;
            }
        });
        this.element.querySelector(WebChat.selector.chatMenuButton).addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (_this.element.querySelector(WebChat.selector.chatMenu).classList.contains(WebChat.cssClass.chatMenuOpen))
                return _this.hideMenu();
            _this.showMenu();
        });
        // this.element.querySelector(WebChat.selector.chatMenuButton).addEventListener('blur', (e: Event) => {
        // 	setTimeout(() => {
        // 		const activeElement = document.activeElement;
        // 		if (!this.element.contains(activeElement)) {
        // 			this.hideMenu();
        // 			this.closeChatFrame();
        // 		}
        // 	}, 5)
        // });
        this.element.querySelector(WebChat.selector.chatMinimize).addEventListener('focus', function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (_this.element.querySelector(WebChat.selector.chatMenu).classList.contains(WebChat.cssClass.chatMenuOpen))
                return _this.hideMenu();
        });
        this.element.querySelector(WebChat.selector.chatMinimize).addEventListener('click', function (e) {
            e.preventDefault();
            _this.closeChatFrame();
            _this.element.classList.add(WebChat.cssClass.chatMinimized);
            document.querySelector(WebChat.selector.chatToggler).focus();
        });
        document.addEventListener('keyup', function (e) {
            if (e.code === 'Escape' && _this.element.classList.contains(WebChat.cssClass.chatOpen)) {
                e.preventDefault();
                _this.closeChatFrame();
                _this.element.classList.add(WebChat.cssClass.chatMinimized);
                document.querySelector(WebChat.selector.chatToggler).focus();
            }
        });
        this.element.querySelector(WebChat.selector.chatClose).addEventListener('click', function (e) {
            e.preventDefault();
            _this.disconnectChat();
            _this.closeChatFrame();
            _this.element.parentNode.removeChild(_this.element);
            document.querySelector(WebChat.selector.chatToggler).focus();
            if (_this.onExitCallback)
                _this.onExitCallback();
        });
        this.element.querySelector(WebChat.selector.chatPrivacyPolicyAccept).addEventListener('click', function (e) {
            e.preventDefault();
            _this.acceptPrivacyPolicyLoadAndConnect();
        });
        this.element.querySelector(WebChat.selector.chatPrivacyPolicyCancel).addEventListener('click', function (e) {
            e.preventDefault();
            _this.closeChatFrame();
        });
        this.element.querySelector(WebChat.selector.chatMenuAboutLink).addEventListener('click', function (e) {
            e.preventDefault();
            _this.setView(WebChatView.About);
        });
        var backButtons = this.element.querySelectorAll(WebChat.selector.chatBack);
        for (var i = 0; i < backButtons.length; i++) {
            backButtons[i].addEventListener('click', function (e) {
                e.preventDefault();
                _this.setView(_this.lastView);
            });
        }
        if (this.sendBox)
            this.sendBox.addEventListener('keyup', function () { return _this.updateSendBoxCounter(); });
        if (this.element.querySelector(WebChat.selector.chatSendForm)) {
            this.element.querySelector(WebChat.selector.chatSendForm).addEventListener('submit', function (e) {
                e.preventDefault();
                if (_this.sendBox.value.trim().length > 0) {
                    _this.store.dispatch({
                        type: 'WEB_CHAT/SEND_MESSAGE',
                        payload: { text: _this.sendBox.value },
                    });
                }
                e.target.reset();
                _this.updateSendBoxCounter();
                _this.sendBox.focus();
            });
        }
        var transcriptButton = this.element.querySelector(WebChat.selector.chatTranscript);
        transcriptButton.addEventListener('click', function (e) {
            e.preventDefault();
            if (_this.transcript.length == 0)
                return;
            var messages = {
                lang: transcriptButton.dataset.messageLang,
                transcript: transcriptButton.dataset.messageTranscript,
                customer: transcriptButton.dataset.messageCustomer,
            };
            var lastEntryFrom;
            var fileContent = "<!DOCTYPE html>\n<html lang=\"".concat(messages.lang, "\">\n\t<head>\n\t\t<meta charset=\"utf-8\" />\n\t\t<meta http-equiv=\"X-UA-Compatible\" content=\"IE=edge\" />\n\n\t\t<title>").concat(_this.template.dataset.botTitle, " - ").concat(messages.transcript, "</title>\n\n\t\t<meta name=\"viewport\" content=\"width=device-width, initial-scale=1\" />\n\n\t\t<style>\n\t\t\thtml,\n\t\t\tbody {\n\t\t\t\tmargin: 0;\n\t\t\t\tpadding: 0;\n\n\t\t\t\tbackground-color: #eeeeee;\n\n\t\t\t\tcolor: #000000;\n\t\t\t\tfont-family: Arial, 'Helvetica Neue', Helvetica, sans-serif;\n\t\t\t\tfont-size: 1em;\n\t\t\t\tline-height: 1.625;\n\t\t\t}\n\n\t\t\tbody {\n\t\t\t\tpadding: 2em;\n\t\t\t}\n\n\t\t\t.container {\n\t\t\t\tmax-width: 800px;\n\t\t\t\tmargin: 0 auto;\n\t\t\t}\n\n\t\t\th1 {\n\t\t\t\tmargin-top: 0;\n\n\t\t\t\tline-height: 1.25;\n\t\t\t}\n\n\t\t\tmain {\n\t\t\t\tpadding: 2em 2em 3em;\n\n\t\t\t\tbackground-color: #ffffff;\n\t\t\t}\n\n\t\t\t.entry {\n\t\t\t\tmargin-bottom: 0.25em;\n\t\t\t}\n\n\t\t\t.entry__bubble {\n\t\t\t\tfloat: left;\n\n\t\t\t\twidth: 3em;\n\t\t\t\theight: 3em;\n\t\t\t\tmargin-right: 1em;\n\n\t\t\t\tbackground-color: #e7e7e7;\n\t\t\t\tborder-radius: 50%;\n\n\t\t\t\tfont-weight: bold;\n\t\t\t\ttext-align: center;\n\t\t\t\tline-height: 3em;\n\t\t\t}\n\n\t\t\t.entry__from {\n\t\t\t\tmargin-top: 1.5em;\n\t\t\t\tmargin-left: 4.25em;\n\n\t\t\t\tcolor: #666666;\n\t\t\t}\n\n\t\t\t.entry:first-child .entry__from {\n\t\t\t\tmargin-top: 0;\n\t\t\t}\n\n\t\t\t.entry__text {\n\t\t\t\tdisplay: inline-block;\n\t\t\t\tmax-width: calc(100% - 4em);\n\t\t\t\tpadding: 1em;\n\t\t\t\tmargin-left: 4em;\n\t\t\t\tbox-sizing: border-box;\n\n\t\t\t\tbackground-color: #e7e7e7;\n\t\t\t\tborder-radius: 12px;\n\t\t\t}\n\n\t\t\t.entry__from + .entry__text {\n\t\t\t\tmargin-left: 0;\n\t\t\t}\n\n\t\t\t.entry__text p {\n\t\t\t\tmargin-top: 0;\n\t\t\t}\n\n\t\t\t.entry__text p:last-child {\n\t\t\t\tmargin-bottom: 0;\n\t\t\t}\n\n\t\t\t.entry--bot .entry__bubble,\n\t\t\t.entry--bot .entry__text {\n\t\t\t\tbackground-color: #e2002a;\n\n\t\t\t\tcolor: #ffffff;\n\t\t\t}\n\n\t\t\t@media only screen and (max-width: 480px) {\n\t\t\t\tbody {\n\t\t\t\t\tpadding: 0.75em;\n\n\t\t\t\t\tfont-size: 0.9em;\n\t\t\t\t}\n\n\t\t\t\tmain {\n\t\t\t\t\tpadding: 1em 0.75em 3em;\n\t\t\t\t}\n\t\t\t}\n\t\t</style>\n\t</head>\n\t<body>\n\t\t<div class=\"container\">\n\t\t\t<h1>").concat(messages.transcript, " (").concat(_this.transcript[0].date.toLocaleDateString(), " - ").concat(_this.transcript[0].date.getHours(), ":").concat(_this.transcript[0].date.getMinutes(), ")</h1>\n\n\t\t\t<main role=\"main\">\n\t\t\t").concat(_this.transcript.map(function (entry) {
                var entryContent = "\n\t\t\t\t\t<div class=\"entry entry--".concat(entry.from.role, "\">\n\t\t\t\t\t\t").concat(lastEntryFrom != entry.from.role ? "\n\t\t\t\t\t\t<div class=\"entry__bubble\">\n\t\t\t\t\t\t\t".concat(entry.from.role == 'bot' ? 'Ö' : 'K', "\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"entry__from\">\n\t\t\t\t\t\t\t<small>").concat(entry.from.name != '' ? entry.from.name : messages.customer, "</small>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t") : '', "\n\t\t\t\t\t\t<div class=\"entry__text\">\n\t\t\t\t\t\t\t<p>").concat(entry.text, "</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t");
                lastEntryFrom = entry.from.role;
                // Entry bubble first letter: ${entry.from.name ? entry.from.name.charAt(0).toUpperCase() : 'K'} -->
                return entryContent;
            }).join(''), "\n\t\t\t</main>\n\t\t</div>\n\t</body>\n</html>\n");
            var blob = new Blob([fileContent], { type: 'text/html;charset=utf-8' });
            (0, file_saver_1.saveAs)(blob, 'chat-protokoll.html');
        });
        this.element.querySelector(WebChat.selector.chatReload).addEventListener('click', function (e) {
            e.preventDefault();
            _this.disconnectChat();
            _this.chatData = _this.loadChatData(function (chatData) {
                _this.chatData = chatData;
                _this.connectChat(_this.chatData);
                _this.setView(WebChatView.Chat);
            });
        });
        // Frame resizing
        (function (that) {
            var resizing = false;
            var startX;
            var startY;
            var startWidth;
            var startHeight;
            var resizeMove = function (e) {
                if (!resizing)
                    return;
                that.element.style.width = (startWidth - (e.clientX - startX)) + 'px';
                that.element.style.height = (startHeight - (e.clientY - startY)) + 'px';
            };
            var resizeUp = function () {
                resizing = false;
                window.removeEventListener('mousemove', resizeMove, false);
                window.removeEventListener('mouseup', resizeUp, false);
            };
            that.resizeCorner.addEventListener('mousedown', function (e) {
                e.preventDefault();
                resizing = true;
                startX = e.clientX;
                startY = e.clientY;
                startWidth = parseInt(document.defaultView.getComputedStyle(that.element).width, 10);
                startHeight = parseInt(document.defaultView.getComputedStyle(that.element).height, 10);
                window.addEventListener('mousemove', resizeMove, false);
                window.addEventListener('mouseup', resizeUp, false);
            });
        })(this);
    };
    WebChat.prototype.afterConnectFulfilled = function () {
        if (this.botOptions.showUploadButton === true) {
            this.sendBox.classList.add(WebChat.cssClass.sendBoxWithUpload);
            this.element.querySelector(WebChat.selector.chatSendBoxMain).classList.add(WebChat.cssClass.sendBoxMainWithUpload);
        }
    };
    WebChat.prototype.onExit = function (cb) {
        this.onExitCallback = cb;
    };
    WebChat.prototype.openChatFrame = function () {
        var _this = this;
        this.element.hidden = false;
        this.element.querySelector(WebChat.selector.chatContent).hidden = false;
        this.element.classList.add(WebChat.cssClass.chatOpen);
        window.getComputedStyle(this.element).display; // Trigger layout for CSS fade-in effect
        this.element.classList.add(WebChat.cssClass.chatFade);
        this.element.classList.remove(WebChat.cssClass.chatMinimized);
        this.removeNewMessageNotification();
        // Accessibility: Set Focus on Close-Button, after chatbot faded in
        setTimeout(function () {
            _this.element.querySelector(WebChat.selector.chatClose).focus();
        }, 500);
    };
    WebChat.prototype.closeChatFrame = function () {
        var _this = this;
        this.element.classList.remove(WebChat.cssClass.chatFade);
        setTimeout(function () {
            _this.element.hidden = true;
            _this.element.classList.remove(WebChat.cssClass.chatOpen);
        }, 500);
    };
    WebChat.prototype.acceptPrivacyPolicyLoadAndConnect = function () {
        var _this = this;
        var button = this.element.querySelector(WebChat.selector.chatPrivacyPolicyAccept);
        var buttonOriginalText = button.textContent;
        button.textContent = button.dataset.messageLoading;
        this.element.querySelector(WebChat.selector.chatPrivacyPolicyCancel).disabled = true;
        (0, utils_1.loadScript)(WebChat.botFrameworkWebChatUrl.replace('{version}', this.botOptions.version), 'botframework-webchat', function () {
            _this.chatData = _this.loadChatData(function (chatData) {
                _this.chatData = chatData;
                button.textContent = buttonOriginalText;
                _this.isPrivacyPolicyAccepted = true;
                _this.connectChat(_this.chatData);
                _this.setView(WebChatView.Chat);
            });
        });
    };
    WebChat.prototype.setView = function (view) {
        this.lastView = this.currentView;
        this.currentView = view;
        var views = this.element.querySelectorAll(WebChat.selector.chatView);
        for (var i = 0; i < views.length; i++) {
            views[i].hidden = true;
        }
        switch (this.currentView) {
            case WebChatView.PrivacyPolicy:
                this.element.querySelector(WebChat.selector.chatPrivacyPolicy).hidden = false;
                this.element.querySelector(WebChat.selector.chatPrivacyPolicyCancel).disabled = false;
                break;
            case WebChatView.About:
                this.element.querySelector(WebChat.selector.chatAbout).hidden = false;
                break;
            case WebChatView.Chat:
                this.element.querySelector(WebChat.selector.chatChatView).hidden = false;
                this.element.querySelector(WebChat.selector.chat).hidden = false;
                break;
        }
    };
    WebChat.prototype.loadChatData = function (cb) {
        return __awaiter(this, void 0, void 0, function () {
            var response, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetch(encodeURI(WebChat.botManagementBaseUrlProd + this.botId))];
                    case 1:
                        response = _a.sent();
                        if (!response.ok)
                            return [2 /*return*/, console.error('Web Chat load error occurred.')];
                        return [4 /*yield*/, response.json()];
                    case 2:
                        data = _a.sent();
                        cb(data);
                        return [2 /*return*/];
                }
            });
        });
    };
    WebChat.prototype.connectChat = function (data) {
        var _this = this;
        this.store = window.WebChat.createStore({}, function (store) { return function (next) { return function (action) {
            if (action.type === 'DIRECT_LINE/CONNECT_FULFILLED') {
                store.dispatch({
                    type: 'WEB_CHAT/SEND_EVENT',
                    payload: {
                        name: 'webchat/join',
                        value: { language: window.navigator.language }
                    }
                });
                if (_this.botOptions.initialMessage) {
                    store.dispatch({
                        type: 'WEB_CHAT/SEND_MESSAGE',
                        payload: { text: _this.botOptions.initialMessage }, // Initial trigger
                    });
                }
                _this.afterConnectFulfilled();
            }
            else if (action.type === 'DIRECT_LINE/INCOMING_ACTIVITY') {
                if (action.payload.activity.from.role === 'bot') {
                    _this.setNewMessageNotificationIfMinimized();
                }
                if (action.payload.activity.text) {
                    _this.transcript.push({
                        text: action.payload.activity.text,
                        from: action.payload.activity.from,
                        timestamp: action.payload.activity.timestamp,
                        date: new Date(),
                    });
                }
            }
            return next(action);
        }; }; });
        window.WebChat.renderWebChat({
            directLine: window.WebChat.createDirectLine({
                token: data.token,
                domain: "https://europe.directline.botframework.com/v3/directline"
            }),
            store: this.store,
            styleOptions: this.styleOptions,
            adaptiveCardHostConfig: this.adaptiveCardHostConfig,
        }, document.getElementById('webchat'));
        // this.store.dispatch({
        // 	type: 'WEB_CHAT/SET_SEND_BOX',
        // 	payload: { text: 'Hallo' },
        // });
        // this.store.dispatch({
        // 	type: 'WEB_CHAT/SUBMIT_SEND_BOX',
        // })
    };
    WebChat.prototype.disconnectChat = function () {
        if (this.store)
            this.store.dispatch({ type: 'DIRECT_LINE/DISCONNECT' });
        this.element.querySelector(WebChat.selector.chatChatView).hidden = true;
        this.element.querySelector(WebChat.selector.chat).hidden = true;
    };
    WebChat.prototype.showMenu = function () {
        this.element.querySelector(WebChat.selector.chatMenu).classList.add(WebChat.cssClass.chatMenuOpen);
        this.element.querySelector(WebChat.selector.chatMenuButton).setAttribute('aria-pressed', 'true');
        this.element.querySelectorAll(WebChat.selector.chatMenuLinks).forEach(function (item) {
            item.setAttribute("tabindex", "0");
        });
    };
    WebChat.prototype.hideMenu = function () {
        this.element.querySelector(WebChat.selector.chatMenu).classList.remove(WebChat.cssClass.chatMenuOpen);
        this.element.querySelector(WebChat.selector.chatMenuButton).setAttribute('aria-pressed', 'false');
        this.element.querySelectorAll(WebChat.selector.chatMenuLinks).forEach(function (item) {
            item.setAttribute("tabindex", "-1");
        });
    };
    WebChat.prototype.updateSendBoxCounter = function () {
        this.sendBoxCounter.textContent = this.sendBox.value.length.toString();
    };
    WebChat.prototype.setNewMessageNotificationIfMinimized = function () {
        if (!this.element.classList.contains(WebChat.cssClass.chatMinimized))
            return;
        this.newMessagesCounter++;
        document.querySelector(WebChat.selector.chatToggler).dataset.count = this.newMessagesCounter.toString();
        document.querySelector(WebChat.selector.chatToggler).classList.add(WebChat.cssClass.chatNotification);
    };
    WebChat.prototype.removeNewMessageNotification = function () {
        this.newMessagesCounter = 0;
        document.querySelector(WebChat.selector.chatToggler).dataset.count = '0';
        document.querySelector(WebChat.selector.chatToggler).classList.remove(WebChat.cssClass.chatNotification);
    };
    WebChat.botVersionDefault = '4.15.7'; // "4.15.7" as coordinated with Stefan Arnez and Daniel Gallob
    WebChat.botFrameworkWebChatUrl = 'https://cdn.botframework.com/botframework-webchat/{version}/webchat.js';
    WebChat.botManagementBaseUrlProd = 'https://powerva.microsoft.com/api/botmanagement/v1/directline/directlinetoken?botId=';
    WebChat.botManagementBaseUrlTest = 'https://webchat-mockbot.azurewebsites.net/directline/token'; // Test URL for events, etc. also POST-Request (https://codez.deedx.cz/posts/web-chat-events-summary/)
    WebChat.cssClass = {
        chatOpen: 'chat-wc-frame--open',
        chatFade: 'chat-wc-frame--fade',
        chatMinimized: 'chat-wc-frame--minimized',
        chatNotification: 'chat-wc-button--notification',
        chatMenuOpen: 'chat-wc-menu--open',
        chatResizeCorner: 'chat-wc-resize-corner',
        offlineMessageOpen: 'chat-wc-offline-message--open',
        sendBoxWithUpload: 'chat-wc-send-box--with-upload',
        sendBoxMainWithUpload: 'webchat__send-box__main--with-upload',
    };
    WebChat.selector = {
        chat: '#webchat',
        chatContent: '.js-chat-wc-content',
        chatToggler: '.js-chat-wc-start',
        chatFrame: '.js-chat-wc-frame',
        chatClose: '.js-chat-wc-close',
        chatMenu: '.js-chat-wc-menu',
        chatMenuButton: '.js-chat-wc-menu-button',
        chatMenuLinks: '.js-chat-wc-menu a',
        chatMenuAboutLink: '.js-chat-wc-menu-about-link',
        chatSendForm: '.js-chat-wc-send-form',
        chatSendBox: '.js-chat-wc-send-box',
        chatSendBoxMain: '.webchat__send-box__main',
        chatSendBoxCounter: '.js-chat-wc-send-box-counter',
        chatOfflineMessage: '.js-chat-wc-offline-message',
        chatOfflineMessageClose: '.js-chat-wc-offline-message-close',
        chatTemplate: '#chat-wc-template',
        chatMinimize: '.js-chat-wc-minimize',
        chatPrivacyPolicy: '.js-chat-wc-privacy-policy',
        chatPrivacyPolicyAccept: '.js-chat-wc-privacy-policy-accept',
        chatPrivacyPolicyCancel: '.js-chat-wc-privacy-policy-cancel',
        chatTranscript: '.js-chat-wc-transcript',
        chatAbout: '.js-chat-wc-about',
        chatChatView: '.js-chat-wc-chat',
        chatView: '.js-chat-wc-view',
        chatReload: '.js-chat-wc-reload',
        chatBack: '.js-chat-wc-back',
    };
    WebChat.sendBoxMaximumLength = 150;
    return WebChat;
}());
exports.WebChat = WebChat;
function initChat(styleOptions, adaptiveCardHostConfig) {
    if (!document.querySelector(WebChat.selector.chatToggler))
        return;
    var button = document.querySelector(WebChat.selector.chatToggler);
    var skipLinks = document.querySelector('.skip-links');
    if (skipLinks) {
        var link = document.createElement("a");
        link.href = "#".concat(button.getAttribute('id'));
        link.className = "screen-reader-text";
        link.accessKey = "2";
        link.textContent = "".concat(button.dataset.skipLinkMessage, " (Alt+2)");
        skipLinks.appendChild(link);
    }
    var webchat;
    if (!(0, chat_lcw_1.isChatButtonVisible)(button.dataset.availableFrom ? parseInt(button.dataset.availableFrom) : 0, button.dataset.availableTo ? parseInt(button.dataset.availableTo) : 24)) {
        if (button.dataset.offlineMessage) {
            var offlineTitle = document.createElement('p');
            offlineTitle.style.fontStyle = 'italic';
            offlineTitle.style.fontSize = '14px';
            offlineTitle.style.opacity = '0.8';
            offlineTitle.textContent = button.dataset.offlineTitle;
            button.appendChild(offlineTitle);
            button.insertAdjacentHTML('afterend', "\n\t\t\t\t<div class=\"chat-wc-offline-message js-chat-wc-offline-message\">\n\t\t\t\t\t<button class=\"js-chat-wc-offline-message-close\">\n\t\t\t\t\t\t<span class=\"ic-close\" aria-hidden=\"true\"></span>\n\t\t\t\t\t\t<span class=\"screen-reader-text\">".concat(button.dataset.closeMessage, "</span>\n\t\t\t\t\t</button>\n\t\t\t\t\t<p>").concat(button.dataset.offlineMessage, "</p>\n\t\t\t\t</div>\n\t\t\t"));
            button.addEventListener('click', function (e) {
                e.preventDefault();
                document.querySelector(WebChat.selector.chatOfflineMessage).classList.add(WebChat.cssClass.offlineMessageOpen);
            });
            document.querySelector(WebChat.selector.chatOfflineMessageClose).addEventListener('click', function (e) {
                e.preventDefault();
                document.querySelector(WebChat.selector.chatOfflineMessage).classList.remove(WebChat.cssClass.offlineMessageOpen);
            });
        }
        return;
    }
    // This can be used to inject alterantive styling for other websites
    // if (document.querySelector('.js-alternative-site')) {
    // 	styleOptions = styleOptionsAlternativeSite as any;
    // }
    button.addEventListener('click', function (e) {
        e.preventDefault();
        if (!webchat) {
            webchat = new WebChat(document.querySelector(WebChat.selector.chatTemplate), styleOptions, adaptiveCardHostConfig);
        }
        else {
            webchat.openChatFrame();
        }
        webchat.onExit(function () {
            webchat = null;
        });
    });
    if (button.dataset.textMobileFadeOut) {
        (0, utils_1.onScrollInterval)(function (latestScrollY, clearScrollInterval) {
            if (latestScrollY > 300) {
                clearScrollInterval();
                button.classList.add('chat-wc-button--text-mobile-fade-out');
            }
        });
    }
}
exports.initChat = initChat;
